import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface LocationModel {
  id: string | null,
  name: string,
  streetLineOne: string | null | undefined,
  streetLineTwo: string | null | undefined,
  city: string | null | undefined,
  state: string | null | undefined,
  postalCode: string | null | undefined,
  country: string | null | undefined,
  customFields: LocationCustomFields[] | null
}
export interface LocationCustomFields {
  id: string | null,
  name: string | null,
  position: string | null,
  type: string | null

}
export interface SubscriptionModel {
  id: string | null
  name: string,
  description: string
}
export interface LocationsConnection {
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string | null;
    endCursor: string | null;
  };
  edges: Array<{
    node: LocationModel;
  }>;
}
export interface PersonModel {
  id: null | string,
  name: null | string,
  company: {
    id: null | string,
    name: null | string,
    paidUsers: null | undefined | number,
    activeUsers: null | undefined | number,
    defaultLocation: LocationModel | null
    subscriptions: Array<SubscriptionModel>
    consentPolicy: boolean,
    parentEmailNeeded: boolean
  },
  locations: Array<LocationModel>
  // locations: LocationsConnection | null
}

export interface PersonStoreState extends PersonModel {
  setState: (data: PersonModel) => void,
  setDefaultLocation: (location: LocationModel) => void,
  destroy: () => void
}

const initialState = {
  id: null,
  company: {
    id: null,
    name: null,
    paidUsers: null,
    activeUsers: null,
    defaultLocation: null,
    subscriptions: [],
    consentPolicy: false,
    parentEmailNeeded: false
  },
  locations: []
}

const usePersonStore = create<PersonStoreState>()(
  /* @ts-ignore */
  persist(
    (set) => ({
      id: null,
      name: null,
      company: {
        id: null,
        name: null,
        paidUsers: null,
        activeUsers: null,
        defaultLocation: null,
        subscriptions: [],
        consentPolicy: false,
        parentEmailNeeded: false
      },
      locations: [],
      setState: (data) => {
        set(() => data)
      },
      setDefaultLocation: (location: LocationModel) => {
        set((state) => ({
          ...state,
          company: {
            ...state.company,
            defaultLocation: location
          },
          locations: [...state.locations]
        }))
      },
      destroy: () => set(() => initialState)
    }),
    {
      name: 'active-person',
      storage: {
        getItem: (name) => {
          const storedValue = sessionStorage.getItem(name);
          return storedValue ? JSON.parse(storedValue) : null;
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name);
        },
      },
    }
  ),
);

export default usePersonStore;